import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  SALES_POINT_PATH,
  SALES_POINT_ADD_PATH,
  SALES_POINT_UPDATE_PATH,
} from "utils/constants/paths";

const SalesPoint = Loadable(React.lazy(() => import("./View")));
const SalesPointAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const SalesPointRoute: IRouteItem = {
  path: SALES_POINT_PATH,
  iconName: "Shop",
  element: React.createElement(SalesPoint),
  name: "Sales Points",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: SALES_POINT_ADD_PATH,
      element: React.createElement(SalesPointAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: SALES_POINT_UPDATE_PATH,
      element: React.createElement(SalesPointAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
